
import { PropType } from "vue";
import { Vue, Options } from "vue-class-component";

@Options({
  name: "ModalV2",
  props: {
    title: {
      default: "",
      type: String
    },
    onClose: {
      default: Function as PropType<() => void>,
      type: Function
    },
    showFooter: {
      default: true,
      type: Boolean
    },
    width: {
      default: "w-8/12",
      type: String
    },
    height: {
      default: "",
      type: String
    },
    isCustomTitle: {
      default: false,
      type: Boolean
    },
    showBorderTitle: {
      default: true,
      type: Boolean
    },
    scrollable: {
      default: true,
      type: Boolean
    },
    isRounded: {
      default: true,
      type: Boolean
    },
    isRoundedLg: {
      default: false,
      type: Boolean
    },
    titlePadding: {
      default: "px-8 py-4",
      type: String
    },
    contentPadding: {
      default: "px-8 py-4",
      type: String
    },
    footerPadding: {
      default: "px-8 py-6",
      type: String
    },
    contentBgColor: {
      default: "bg-white",
      type: String
    },
    footerBgColor: {
      default: "bg-gray-lp-700",
      type: String
    },
    marginHeader: {
      default: "mb-2",
      type: String
    },
    marginFooter: {
      default: "mt-2",
      type: String
    },
    isShadows: {
      default: true,
      type: Boolean
    },
    borderTop: {
      default: "border-t border-gray-lp-400",
      type: String
    }
  }
})
export default class extends Vue {}
